// @flow

export type GuidePayloadType = {|
  id: number | string,
  namespace: string,
  type: string
|};

export type FromGuideType = (initializationVectorValue: string, expectedNamespace: string, expectedResourceTypeName: string, guide: string) => GuidePayloadType;

export type ToGuideType = (initializationVectorValue: string, namespace: string, type: string, id: number | string) => string;
